export default store => {
    store.subscribe((m, state) => {

        // Save the entire state to Local Storage
        if( localStorage ) {
            localStorage.setItem('appState', JSON.stringify(state));
        }

    });
};